import { useState, useEffect } from "react";
import apiClient from "../services/api";

let cache = null;

/** Billing categories + master-item billing lookup (materials by id, misc by id). Cached per session. */
export const useBillingCategories = () => {
  const [data, setData] = useState(cache || { categories: [], materials: {}, misc: {}, miscByDescription: {}, perJobMaterials: new Set(), perJobMisc: new Set() });

  useEffect(() => {
    if (cache) return;
    let active = true;
    Promise.all([apiClient.get(`/settings/options`), apiClient.get(`/materials`)])
      .then(([optRes, matRes]) => {
        cache = {
          categories: optRes.data?.billing_categories || [],
          materials: Object.fromEntries((matRes.data || []).filter((m) => m.billing_category).map((m) => [m.id, m.billing_category])),
          misc: Object.fromEntries((optRes.data?.misc_items || []).filter((m) => m.billing_category).map((m) => [m.id, m.billing_category])),
          miscByDescription: Object.fromEntries((optRes.data?.misc_items || []).filter((m) => m.billing_category && m.description).map((m) => [m.description.trim().toLowerCase(), m.billing_category])),
          // master items flagged "set billing category in bid sheet" — the bid line must choose one
          perJobMaterials: new Set((matRes.data || []).filter((m) => m.billing_category_per_job).map((m) => m.id)),
          perJobMisc: new Set((optRes.data?.misc_items || []).filter((m) => m.billing_category_per_job).map((m) => m.id)),
        };
        if (active) setData(cache);
      })
      .catch(() => {});
    return () => { active = false; };
  }, []);

  return data;
};

export const invalidateBillingCategories = () => { cache = null; };
